const HotelScore = props => {
    
    const { score, reviews , max} = props;

    if (!(score && reviews && reviews > 0)) {
        return null;
    }

    let pointTitle = "";
    let pointColor = "";

    if (score/max >= .9) {
        pointTitle = "عالی"
        pointColor = "rgb(20, 148, 15)";
    } else if (score/max >= .8) {
        pointTitle = "خیلی خوب"
        pointColor = "rgb(108, 191, 74)";
    } else if (score/max >= .7) {
        pointTitle = "خوب"
        pointColor = "rgb(163, 205, 77)";
    } else if (score/max >= .5) {
        pointTitle = "معمولی"
        pointColor = "rgb(243, 163, 36)";
    } else {
        pointTitle = "معمولی"
        pointColor = "#FF5722";
    }

    return (
        <div className={`${props.small?"font-12":""} ${props.className || ""}`}>
            <span className={`${props.small?"semi-bold":"font-18 bold"}`}> {score} از {props.max}  </span> {pointTitle} ({props.reviews} نظر) 
        </div>
    )
};

export default HotelScore;